module.exports = __webpack_public_path__ + "img/onboardingFormDefaultPhoto_en.d70dc56d.svg";